export class DialogUnlockFolderRequestData {
	/**
	 * Constructeur.
	 */
	public constructor(
		public userName: string,
		public folderName: string,
		public delay: number
	) {}
}
